import HowToPlay from './components/HowToPlay.js';
import MyAccount from './components/MyAccount.js';
import PopupNav from './components/PopupNav.js';
import Stats from './components/Stats.js';

{
    const howToPlay = document.querySelector(".how-to-play");
    if (typeof howToPlay != "undefined" && howToPlay) {
        HowToPlay();
    }
}

{
    const nav = document.querySelector(".header__icon--nav");
    if (typeof nav != "undefined" && nav != null) {
        PopupNav();
    }
}

{
    const stats = document.querySelector(".stats-modal");
    if (typeof stats != "undefined" && stats != null) {
        Stats();
    }
}

{
    const myAccount = document.querySelector(".my-account-modal");
    if (typeof myAccount != "undefined" && myAccount) {
        MyAccount();
    }
}